import { getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createEarnUserDataSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.EARN_USER_DATA,
        ...getUserAndEventTime(),
        data: {
            netHourlyRate: 18.44,
            unpaidHoursInPayPeriod: 14,
            currentPayPeriodStart: '2020-01-13T12:00:00.000Z'
        }
    };
};
//# sourceMappingURL=earn-user-data.js.map